import type {Painter} from '../painter/types'
import type {LvsColorKey} from '../lvs-colors'
import type {ArrowGeometry} from './geometry'

/**
 * Render an arrow polygon into any Painter, optionally translated by
 * (x, y) mm. Single source of truth — both the on-screen <Arrow>
 * component and the PDF export call this with their respective adapter.
 */
export function paintArrow(
    p: Painter,
    geometry: ArrowGeometry,
    fillKey: LvsColorKey,
    x = 0,
    y = 0
): void {
    if (geometry.vertices.length === 0) return
    const verts =
        x === 0 && y === 0 ?
            geometry.vertices
        :   geometry.vertices.map(v => ({x: v.x + x, y: v.y + y}))
    p.fillPolygon(fillKey, verts)
}
